/**
 * Field — reusable form-field wrapper used by AdminExpenseModal et al.
 * Batch #14.154 — extracted from AdminPmsQueuePage.jsx during refactor.
 */
export default function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-[10px] text-slate-600 font-semibold uppercase tracking-wider">{label}</span>
      <div className="mt-1">{children}</div>
    </label>
  );
}
